export const barcodenotext = {
  barcodenotext: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 200,
    },
  },
}

export const barcodewithtext = {
  barcode: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 200,
    },
  },
}

export const qrcode = {
  qrcode: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 200,
      lock_ratio: true,
    },
  },
}

export const appLogo = {
  aplogo: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 200,
    },
  },
}

export const fieldselect = {
  fieldselect: {
    position: {
      top: 80,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 100,
    },
    field_id: '',
    font_size: 16,
    font_family: 'Arial',
    color: '000000',
  },
}

export const companyLogoData = {
  companylogo: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 100,
    },
    name: '',
    image: '',
  },
}
